module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1duAUar3HckyqEKEUw02qc-dcb166220d3f7e3e2142760bcf45f645.jpg";